import jsCookie from 'js-cookie';
import { UserService } from '@/service';

export const removeSessionInfo = () => {
  jsCookie.remove('session_id');
  jsCookie.remove('state');
};

export const logout = async (redirectUrl?: string) => {
  const logoutRes = await UserService.logout();
  if (logoutRes.code) {
    return;
  }
  removeSessionInfo();
  window.location.href = `${
    process.env.REACT_APP_DSERS_USER_CENTER_HOST
  }login?redirect_url=${encodeURIComponent(`${window.location.origin}/management/`)}` as string;
};
